import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import 'react-reflex/styles.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import './i18n';
import { SideBarProvider } from './context/SideBarContext';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { TasksProvider } from './context/TasksContext';

const basename = process.env.REACT_APP_BASENAME || "/";

ReactDOM.render(
    <React.StrictMode>
        <AuthProvider>
            <SideBarProvider>
                <TasksProvider>
                    <BrowserRouter basename={basename}>
                        <App />
                        <ToastContainer theme='colored' />
                    </BrowserRouter>
                </TasksProvider>
            </SideBarProvider>
        </AuthProvider>
    </React.StrictMode>,
    document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
